import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import type { TimelineItemProps } from "antd";
import { Timeline } from "antd";
import React from "react";
import styles from "./index.module.less";

// ==================== 类型定义 ====================
interface ProcessTimelineItem {
  id: string;
  name: string;
  role: string;
  status: "start" | "pass" | "pending" | "rejected";
  timestamp: string;
  comment?: string;
}

interface ProcessTimelineProps {
  items: ProcessTimelineItem[];
  showFinishedFlag?: boolean;
}

// ==================== 常量配置 ====================
const STATUS_CONFIG = {
  start: {
    icon: <CheckCircleFilled color="#00B029" style={{ fontSize: 16 }} />,
    color: "#00B42A",
    label: "已提交",
  },
  pass: {
    icon: <CheckCircleFilled color="#00B029" style={{ fontSize: 16 }} />,
    color: "#00B42A",
    label: "审核通过",
  },
  pending: {
    icon: <div className={styles.pendingIcon}></div>,
    color: "#F47600",
    label: "待审核",
  },
  rejected: {
    icon: <CloseCircleFilled color="#E80000" style={{ fontSize: 16 }} />,
    color: "#E80000",
    label: "审核驳回",
  },
} as const;

// ==================== 渲染函数 ====================
const renderStatus = (status: ProcessTimelineItem["status"]) => {
  const config = STATUS_CONFIG[status];
  return (
    <div style={{ marginRight: 0, color: config.color }}>{config.label}</div>
  );
};

const renderProcessItem = (item: ProcessTimelineItem, index: number) => {
  return (
    <div className={styles.processItemContainer}>
      <div className={styles.processItemContent}>
        <div className={styles.processItemHeader}>
          <div className={styles.processItemInfo}>
            <div className={styles.processItemName}>{item.name}</div>
            <div className={styles.processItemRole}>{item.role}</div>
            <div className={styles.processItemTime}>{item.timestamp}</div>
          </div>
        </div>
        {item.status === "rejected" && item.comment && (
          <div className={styles.processItemComment}>
            驳回原因：{item.comment}
          </div>
        )}
      </div>

      <div className={styles.processItemStatus}>
        {renderStatus(item.status)}
      </div>
    </div>
  );
};

// ==================== 主组件 ====================
const ProcessTimeline: React.FC<ProcessTimelineProps> = ({
  items,
  showFinishedFlag,
}) => {
  let timelineItems: TimelineItemProps[] = items.map((item, index) => {
    const config = STATUS_CONFIG[item.status];

    return {
      dot: <div>{config.icon}</div>,
      children: renderProcessItem(item, index),
      color: config.color,
    };
  });

  const finishedNode = {
    dot: <div className={styles.endPoint}></div>,
    children: <div className={styles.endPointText}>流程已结束</div>,
  };

  if (showFinishedFlag) {
    timelineItems = [...timelineItems.slice(0, -1), finishedNode];
  }

  return (
    <div className={styles.processTimelineContainer}>
      <Timeline items={[...timelineItems]} />
    </div>
  );
};

export type { ProcessTimelineItem, ProcessTimelineProps };
export default ProcessTimeline;
